/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fund_VehicleInputs */

const en_fund_vehicle = /** @type {(inputs: Fund_VehicleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fund vehicle`)
};

/**
* | output |
* | --- |
* | "Fund vehicle" |
*
* @param {Fund_VehicleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const fund_vehicle = /** @type {((inputs?: Fund_VehicleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fund_VehicleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fund_vehicle(inputs)
});